angular.module("KhBase").factory("FarmFieldListFactory", ["$resource", function ($resource) {
    return $resource('api/v1.0/fms/farmfield/get/:field_slug?data_format=geojson', {field_slug: '@field_slug'});
}]);
